export default class Popup {
    constructor() {
        this.popup = document.querySelector('[data-content-popup]');
        if (!this.popup) return
        this.trigger = document.querySelector('[data-content-popup-trigger]');
        this.close = document.querySelector('[data-content-popup-close]');


        this.trigger.addEventListener('click', e => {
            this.popup.classList.toggle('open');
        });

        this.popup.addEventListener('click', e => {
            if (e.target.classList.contains('content-popup--content')) {
                this.popup.classList.toggle('open');
            }
        });

        this.close.addEventListener('click', e => {
            this.popup.classList.remove('open');
        });
    }
}
